import {Routes} from '@angular/router';
import {AccessDeniedComponent} from '@shared/components';
import {AnonymousGuardService} from './mt-security/anonymous.guard.service';
import {AuthGuardService} from './mt-security/auth.guard.service';

export const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./login/login.routes'),
        canActivate: [AnonymousGuardService]
    },
    {
        path: '',
        loadChildren: () => import('./console/console.routes'),
        canActivate: [AuthGuardService]
    },
    {path: 'access', component: AccessDeniedComponent},
    {
        path: '**',
        redirectTo: '',
        canActivate: [AuthGuardService]
    },
];
